import { render, staticRenderFns } from "./UnknownOrCopy.vue?vue&type=template&id=b23541f0&"
import script from "./UnknownOrCopy.vue?vue&type=script&lang=js&"
export * from "./UnknownOrCopy.vue?vue&type=script&lang=js&"
import style0 from "./UnknownOrCopy.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports